import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IDescription} from "../../../../../../utils/interfaces/service/description/IDescription";


const useApiCreateDescription = (): UseMutationResult<IDescription, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IDescription> {
        try {
            const response = await post(`/api/company/${companyToken}/service/description/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IDescription, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetDescriptions", obj.scope]});
            },
        }
    );
};


export default useApiCreateDescription;